/* global process */
/**
 * True when the app runs as the Cypress application-under-test.
 *
 * 1) Build-time: `yarn cypress` uses webpack + `.env.cypress` where
 *    `REACT_APP_ENVIRONMENT` is `cypress` — survives `window:before:load` /
 *    iframe timing issues with the AUT.
 * 2) Runtime: `window.Cypress` or `__ADS_CYPRESS_AUT` (support/e2e.js).
 * 3) sessionStorage `ads.cypress.aut` (mirrors the flag; survives odd AUT timing).
 */
import { ADS_CYPRESS_AUT_STORAGE_KEY } from "./cypressE2eFlags";

const normalizeReactAppEnv = (value) =>
  String(value == null ? "" : value)
    .trim()
    .replace(/^["']|["']$/g, "")
    .toLowerCase();

export const getIsCypressAut = () => {
  try {
    const v = process.env.REACT_APP_ENVIRONMENT;
    if (normalizeReactAppEnv(v) === "cypress") {
      return true;
    }
  } catch (_e) {
    // non-webpack / tests without DefinePlugin
  }
  try {
    if (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(ADS_CYPRESS_AUT_STORAGE_KEY) === "1"
    ) {
      return true;
    }
  } catch (_e) {
    // ignore storage access errors
  }
  return (
    typeof window !== "undefined" &&
    (Boolean(window.Cypress) || Boolean(window.__ADS_CYPRESS_AUT))
  );
};
